import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from '@/locales/en.json';
import pt from '@/locales/pt.json';

Vue.use(VueI18n);

export default new VueI18n({
  locale: import.meta.env.VITE_I18N_LOCALE || 'en',
  fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'en',
  messages: {
    en,
    pt,
  },
  silentTranslationWarn: true,
});
